export default "__VITE_ASSET__DxaKsx5X__"